const palette = {
  theme: {
    GatewayGreen: {
      DEFAULT: '#78A22F',
      50: '#CDE5A4',
      100: '#C4E094',
      200: '#B3D775',
      300: '#A2CE55',
      400: '#8FC238',
      500: '#78A22F',
      600: '#587722',
      700: '#384B16',
      800: '#172009',
      900: '#000000',
      950: '#000000',
    },
    GatewayBlue: {
      DEFAULT: '#002B54',
      50: '#0D89FF',
      100: '#007FF7',
      200: '#006ACE',
      300: '#0055A6',
      400: '#00407D',
      500: '#002B54',
      600: '#000E1C',
      700: '#000000',
      800: '#000000',
      900: '#000000',
      950: '#000000',
    },
    Purple: {
      DEFAULT: '#824E9F',
      50: '#D7C3E2',
      100: '#CDB5DB',
      200: '#BB9ACD',
      300: '#A97FC0',
      400: '#9663B3',
      500: '#824E9F',
      600: '#633C79',
      700: '#442954',
      800: '#26172E',
      900: '#070408',
      950: '#000000',
    },
    Grey: {
      DEFAULT: '#CFD4D8',
      50: '#FFFFFF',
      100: '#FFFFFF',
      200: '#FFFFFF',
      300: '#FCFCFD',
      400: '#E6E8EA',
      500: '#CFD4D8',
      600: '#B0B8BF',
      700: '#919DA6',
      800: '#72818D',
      900: '#59646E',
      950: '#4C565E',
    },
    Orange: {
      DEFAULT: '#F8971D',
      50: '#FEE9CF',
      100: '#FDE0BB',
      200: '#FCCE94',
      300: '#FABB6C',
      400: '#F9A945',
      500: '#F8971D',
      600: '#D67A07',
      700: '#A05B05',
      800: '#693C03',
      900: '#331D02',
      950: '#180E01',
    },
    LightGreen: {
      DEFAULT: '#B4CC95',
      50: '#FFFFFF',
      100: '#FFFFFF',
      200: '#EEF4E8',
      300: '#DBE7CC',
      400: '#C7D9B1',
      500: '#B4CC95',
      600: '#99BA6F',
      700: '#7EA34E',
      800: '#607D3C',
      900: '#43572A',
      950: '#354421',
    },
    LightBlue: {
      DEFAULT: '#AEC5E7',
      50: '#FFFFFF',
      100: '#FFFFFF',
      200: '#FFFFFF',
      300: '#EDF2FA',
      400: '#CDDCF0',
      500: '#AEC5E7',
      600: '#83A6DA',
      700: '#5787CD',
      800: '#366AB7',
      900: '#29518B',
      950: '#234476',
    },
    WashedNavy: {
      DEFAULT: '#37628A',
      50: '#A0BDD9',
      100: '#91B3D3',
      200: '#749FC8',
      300: '#578BBC',
      400: '#4377A7',
      500: '#37628A',
      600: '#274662',
      700: '#17293A',
      800: '#070D12',
      900: '#000000',
      950: '#000000',
    },
  },
  base: {
    dark: {
      DEFAULT: '#000000',
      50: '#5C5C5C',
      100: '#525252',
      200: '#3D3D3D',
      300: '#292929',
      400: '#141414',
      500: '#000000',
      600: '#000000',
      700: '#000000',
      800: '#000000',
      900: '#000000',
      950: '#000000',
    },
    light: {
      DEFAULT: '#FFFFFF',
      50: '#FFFFFF',
      100: '#FFFFFF',
      200: '#FFFFFF',
      300: '#FFFFFF',
      400: '#FFFFFF',
      500: '#FFFFFF',
      600: '#E3E3E3',
      700: '#C7C7C7',
      800: '#ABABAB',
      900: '#8F8F8F',
      950: '#818181',
    },
  },
}

const hexBasedPalette = {
  // defining this palette of the base colours will allow us better interaction with the colours pickers from the CMS that only return the colour value.
  // one limitation of this is that only the '500' level colours will be supported in the picker, although the colour variable can be manipulated via the shade selectors in the templates.
  '000000': palette.base.dark,
  ffffff: palette.base.light,
  cfd4d8: palette.theme.Grey,
  f8971d: palette.theme.Orange,
  b4cc95: palette.theme.LightGreen,
  aec5e7: palette.theme.LightBlue,
  '37628a': palette.theme.WashedNavy,
  '824e9f': palette.theme.Purple,
  '002b54': palette.theme.GatewayBlue,
  '78a22f': palette.theme.GatewayGreen,
}
const paletteNames = [...Object.keys(palette.theme), ...Object.keys(palette.base), ...Object.keys(hexBasedPalette)]

const thirdParty = {
  calculators: {
    test: {
      // we test against this selector to see if we need to load the third party script.
      // selector: 'iframe[src*="gbst.com"]',
      selector: 'iframe',
      // list the attributes we need to get from the selector to make it work.
      attributes: ['id'],
      // list any subelements that we need to get from the selected element.
      // note that in this instance because we are loading from an iframe we cannot access any DOM elements within, so anything here will return and empty NodeList.
      elements: [],
    },
    script: {
      // if we do need to run the script, here's the src and an ID so that we only load it once.
      src: 'https://calculators.gbst.com/clients/standard_suite/lib/iframeResizer.min.js',
      id: 'iframeResizerScript',
      // we add a callback function to be run once that loaded script's onload event fires.
      callback: null,
    },
    callback: {
      attributes: function ({ id }) {
        if (typeof iFrameResize === 'function') {
          iFrameResize({}, `#${id}`)
        }
      },
      elements: function (elements) {
        // any function that requires subelements of the selected parents elements goes in here.
      },
    },
  },
}

/* if you are adding a local font for a client, you will also need to edit fe-src\src\scss\base\_localFonts.scss to add the font-family details */
const viteFontSetup = {
  // google: {
  //   families: [
  //     {
  //       name: 'Playfair Display',
  //       styles: 'ital,wght@0,400;0,700;0,900;1,400;1,700;1,900',
  //       defer: true,
  //     },
  //   ],
  // },
  custom: {
    families: [
      {
        name: 'HelveticaNeue-Regular',
        local: 'HelveticaNeue-Regular',
        src: './public/fonts/5664093/08b57253-2e0d-4c12-9c57-107f6c67bc49.woff2',
        transform(font) {
          if (font.basename === 'HelveticaNeue-Regular') {
            // update the font weight
            font.weight = 400
          }
          // we can also return null to skip the font
          return font
        },
      },
      {
        name: 'HelveticaNeue-Bold',
        local: 'HelveticaNeue-Bold',
        src: './public/fonts/1f4274cd-2674-481e-9023-69e33ffca161.woff2',
        transform(font) {
          if (font.basename === 'HelveticaNeue-Bold') {
            // update the font weight
            font.weight = 700
          }
          // we can also return null to skip the font
          return font
        },
      },
    ],
  },
}

const themeConfig = {
  thirdParty: thirdParty,
  paletteNames: paletteNames,
  hexBasedPalette: hexBasedPalette,
  settings: {
    // this will close all other accordions in the same component when a new one is open
    onlyOneAccordionOpen: false,
    // this setting will resetting any/all breakpoints for your site.
    // this is mostly useful for locking the max-content width to a certain size.
    // the default tailwind setting for this is 1536px.
    // values: false, or an object something like:
    // {
    //   '2xl': '1440px',
    // },
    breakPoints: {},
    // this setting will set a more 'readable' width constraint to various components.
    // it's probably a good idea to turn it on, but the default will be off, so as not to break existing cient designs.
    useReadableContentWidth: false,
    // there are two types of button available, rounded rectangles and pill-shaped.
    // set this to true to lock all buttons to pill-shaped, or false to default to rounded-rectangles
    useOnlyPillButtons: true,
    // if a button colour selection matches the colour of a button in the component
    // true: switch to a white button
    // false: switch to a lighter shadew of the same theme colour.
    useWhiteButtonsOnCollision: true,
    showExternalLinkIcons: false,
    heroForegroundImages: false,
    // useTextShadow: ['images', 'always'] | false
    // images is for sections with background images
    // always is for... always
    // false is don't use shadows at all.
    useTextShadow: 'images',
    rates: {
      // for use in rates cards etc, where possible stack the %pa text.
      // this will not work for strings entered via RTE fields
      stackPercent: true,
      // if the rates values should use the 'hero' font, if provided
      // this will apply to all values across the site, except those entered by RTE fields
      useHeroFont: true,
      // if the rates values should be larger than the standard height
      // this will apply to all values across the site, except those entered by RTE fields
      // this should be a set of tailwind classes that will set the font-size correctly.
      useAlternateSize: 'text-4xl lg:@sm/callout:text-6xl leading-none',
    },
    ratesCard: {
      highlightProductTitle: 'text-primary-500',
      highlightDescription: false,
      highlightRate: true,
      showVariantNames: true,
      showDisclaimersFromCMS: true,
      disclaimerIcons: ['*', '†', '‡', '§', '||', '¶'],
    },
    buttonShades: {
      standard: {
        base: '500',
        hover: '400',
      },
      muted: {
        base: '300',
        hover: '400',
      },
    },
    backToTop: 'GatewayGreen-500',

    searchPageStub: 'search',
    useCMSMenuAccents: true,
    hero: {
      card: {
        shadow: {
          base: 'inherit',
          // it is unlikely that you wil want this to be the full colour, as it will be quite stark, so it's recommended that you specifically add the class `shadow-[color-value]/50` to the safelist below to ensure that the colour choice is loaded (unless you use 'inherit' of course).
          hover: 'inherit',
        },
      },
    },
    nav: {
      desktop: {
        base: 'Grey-800',
        active: 'GatewayBlue-500',
        highlight: 'GatewayBlue-500',
      },
      mobile: {
        base: 'Grey-800',
        active: 'Grey-890',
      },
      footer: {
        base: palette.theme.Grey['300'],
        disclaimers: 'primary-300',
        inheritLinkStyle: false,
      },
      sticky: {
        base: 'GatewayBlue-500',
      },
      breadcrumbs: {
        base: palette.theme.light,
      },
      search: {
        base: 'Grey-800',
      },
    },
    alerts: {
      success: {
        bg: 'green-50',
        text: 'green-50-text',
      },
      primary: {
        bg: 'GatewayGreen-50',
        text: 'GatewayGreen-50-text',
      },
      danger: {
        bg: 'red-500',
        text: 'white',
      },
      warning: {
        bg: 'yellow-50',
        text: 'yellow-700',
      },
      light: {
        bg: 'slate-50',
        text: 'GatewayBlue-600',
      },
      dark: {
        bg: 'GatewayBlue-600',
        text: 'WashedNavy-100',
      },
    },
  },
  // this flag will tell the system to generate text-colors for each base colour that is present.
  detectInverseText: true,
  // these colours can be presented in either HEX or RBG notation, either will work for the inverse text detection
  colors: {
    // if the client just has a set of base colours they can be defined here, and it will generate a tailwind-compatible set of shades based on these as the central (-500 value) colour.
    base: {
      // base: palette.base.light,
      // primary: palette.base.light,
      // secondary: palette.theme.irisblue[500],
      // tertiary: palette.base.light,
      // dark: palette.base.dark,
      // light: palette.base.light,
      // ...palette.theme
    },
    // if there are explicitly defined shades for a given client, they can be added here.
    // if there is a name collision between a shade and a built-in tailwind colour these will become the truth

    /*
      IMPORTANT: using shades will require editing of the tailwind.config.js file to include all the shades and variants inside the safelist to ensure they are always loaded and available to dynamically created content
    */

    shades: {
      // we map the palette onto the various "themes" in use
      base: palette.base.light,
      primary: palette.theme.GatewayBlue,
      secondary: palette.theme.GatewayGreen,
      tertiary: palette.base.light,
      dark: palette.base.dark,
      light: palette.base.light,
      // then we add the entire palette even though it should not be required
      ...palette.theme,
      // and then a palette with the hex codes of the colours as the key
      ...hexBasedPalette,
    },
    text: {
      // the color for dark text on a light background, not the color that goes over dark
      light: '#000000',
      // the color for light text on a dark background, not the color that goes over light
      dark: '#ffffff',
    },
    link: {
      default: {
        // the color for dark text on a light background, not the color that goes over dark
        light: palette.theme.GatewayGreen[500],
        // the color for light text on a dark background, not the color that goes over light
        dark: palette.theme.GatewayBlue[500],
      },
      hover: {
        // the color for dark text on a light background, not the color that goes over dark
        light: palette.theme.GatewayGreen[700],
        // the color for light text on a dark background, not the color that goes over light
        dark: palette.theme.GatewayBlue[300],
      },
    },
  },
  font: {
    vite: viteFontSetup,
    family: {
      // not limited to just 'sans' and 'serif', can be any arbitrary name

      // Instructions for adding a font from Google.
      /*
        - near the top of this file is a const viteFontSetup. 
        - this is an object that will load a series of one or more google fonts, with selectable weights.
        - once this is filled in using the options that can be found at https://github.com/cssninjaStudio/unplugin-fonts you need to:
          - run the build script
          - open the resulting index.html file
          - look for lines that look like 
              <link rel="preconnect" href="https://fonts.gstatic.com/" crossorigin="anonymous">
              <link rel="preload" as="style" onload="this.rel='stylesheet'" href="https://fonts.googleapis.com/css2?family=Playfair Display:ital,wght@0,400;0,700;0,900;1,400;1,700;1,900&display=swap">
            - they will be different depending on the fonts you are installing, so be careful. DO NOT COPY AND PASTE FROM HERE
        - Copy those lines and paste them into the Header Scripts area of the site in the CMS
          - the plugin adds them to the index.html, but we are not using that as our launchpad for the site, so need to work around it.
        - Save, and test locally.
        - The same piece of code will need to be added to each envGreyment, per client.
        - add the font details as below, using the display name of the font you are trying to load, per Google's naming in the related font page.
        - profit!
      */

      // Font names with spaces can be surrounded with "" inside the string.
      sans: ['"HelveticaNeue-Regular"', '"Helvetica Neue"', 'sans-serif'],
    },
  },
  // these settings will change the colour related classes that are added to the tailwind safelist.
  // because many of our classes are dynamically added they do not get picked up as being in use when tailwind does its internal tree-shaking.
  // adding classes to the safelist forces them to be included, at the cost of potentially unneccessary rules being added.
  // tailwind colour classes can get pretty special, from simple items like "bg-red-500" or "text-black-500" to "max-lg:hover:text-jazzberry-300-text".
  tailwind: {
    // this is the list of shades that will be included in the final build.
    // Once theming is complete this should be reduced to what we know is in use to reduce CSS file size.
    shades: [50, 100, 200, 300, 400, 500, 700, 800, 900],
    // this is the list of prefix stubs that are required for use in the site.
    types: ['bg', 'outline', 'text', 'border', 'decoration', 'divide'],
    // these are the variants of the classes used to cover the "state" or "breakpoint" options of the classes
    variants: ['', 'group-hover:', 'hover:', 'focus-visible:', 'md:', 'max-md:', 'max-lg:', 'lg:', 'hover:lg:'],
    // these are the suffix stubs that modify the action variants of the colours.
    modifiers: ['', '-text', '-link', '-hover'],
    // this is the current list of safelist tailwind classes required for the theme to function.
    // this can be a string, or an object that matches a pattern. This object may include a variants key that is similar to the above variants key, but customised for that pattern.
    // there are currently other patterns described in the base tailwind.config.js, the one here is a small example of usage (that we also need, so please don't remove it)
    safelist: [
      'text-light',
      'text-dark',
      'rounded-l-full',
      'rounded-r-full',
      'divide-y',
      'font-normal',
      'bg-dark',
      'text-dark-text',
      'bg-light',
      'text-light-text',
      'shadow-white',
      'shadow-black',
      'banner',
      {
        pattern: /bg-gradient-(t|r|l)/,
      },
      {
        pattern: /grid-cols-(1|2|3|4)/,
        variants: ['md', 'lg', 'xl', '2xl'],
      },
      {
        pattern: /divide-(x|y)-(2|4|6)/,
        variants: ['md', 'lg', 'xl', '2xl', 'max-xl', 'max-md'],
      },
      {
        pattern: /divide-(x|y)/,
        variants: ['md', 'lg', 'xl', '2xl', 'max-xl', 'max-md'],
      },
      {
        pattern: /(m|p)(x|y|t|b|r|l)-(1|2|4|6|8)/,
        variants: ['md', 'lg', 'xl', '2xl', 'max-xl', 'max-md'],
      },
      {
        pattern: /^text-(xl|2xl|3xl|4xl|5xl|6xl)$/,
        variants: ['max-md', 'max-lg', 'lg:@sm/callout'],
      },
    ],
    // this is a list of specific classes that we do not want to include in the build.
    // this cannot be a pattern, like the safelist, and must be a discrete array of strings.
    // this is probably not going to be necessary due to configuration optimisations that have already taken place.
    blocklist: [],
  },
}

themeConfig.tailwind.safelist.push(`shadow-${themeConfig.settings.hero.card.shadow.base}/50`)
themeConfig.tailwind.safelist.push(`hover:shadow-${themeConfig.settings.hero.card.shadow.hover}/50`)

export default themeConfig
